import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/_settings/einstellungen/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$company/buchhaltung/einstellungen/eckdaten",
      params: { company: params.company },
      replace: true,
    });
  },
});
